import { client } from './client'

export const SIGNED_BI_FILE_NAME = 'bulletin-inscription-iperia-signe.pdf'

// The signed BI is streamed by the CRM, which proxies Edusign: expect a slow first byte.
const SIGNED_BI_TIMEOUT_MS = 30000

async function fetchSignedBi(url: string, params?: Record<string, string>): Promise<Blob> {
  const response = await client.get(url, {
    params,
    responseType: 'blob',
    timeout: SIGNED_BI_TIMEOUT_MS,
  })
  return response.data as Blob
}

export function saveBlobAsFile(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

export async function downloadLearnerSignedBi(globalId: string): Promise<void> {
  const blob = await fetchSignedBi(`/registration/${globalId}/iperia/bi_document/`)
  saveBlobAsFile(blob, SIGNED_BI_FILE_NAME)
}

export async function downloadParentSignedBi(token: string): Promise<void> {
  const blob = await fetchSignedBi('/registration/iperia/parent_document/', { token })
  saveBlobAsFile(blob, SIGNED_BI_FILE_NAME)
}
